<template>
  <div class="products-contain">
    <div style="background: #E9F3FF;  padding-top: 60px;padding-bottom: 40px">
      <section class="products en">
        <h2>Our Services</h2>
        <div :class="is_en ? 'services-grid en' : 'services-grid'">
          <!-- 再制造/翻新/高级别维修 -->
          <div class="service-card">
            <h3 class="service-title">{{ $t('products.remanufacturing.title') }}</h3>
            <p class="service-desc">{{ $t('products.remanufacturing.desc') }}</p>
            <div class="image-placeholder strong-img">
              <img src="@/assets/home2/8.png" alt="">
            </div>
          </div>

          <!-- 全球售后服务业务咨询 -->
          <div class="service-card">
            <h3 class="service-title">{{ $t('products.global_after_sales.title') }}</h3>
            <p class="service-desc">{{ $t('products.global_after_sales.desc') }}</p>
            <div class="image-placeholder strong-img">
              <img src="@/assets/home2/15.png" alt="">
            </div>
          </div>
          <!-- 售后备件生命周期管理 -->
          <div class="service-card">
            <h3 class="service-title">{{ $t('products.parts_lifecycle.title') }}</h3>
            <p class="service-desc">{{ $t('products.parts_lifecycle.desc') }}</p>
            <div class="image-placeholder strong-img">
              <img src="@/assets/home2/9.png" alt="">
            </div>
          </div>

          <!-- 全球售后服务管理模式 -->
          <div class="service-card">
            <h3 class="service-title">{{ $t('products.service_management.title') }}</h3>
            <p class="service-desc">{{ $t('products.service_management.desc') }}</p>
            <div class="image-placeholder strong-img">
              <img src="@/assets/home2/17.png" alt="">
            </div>
          </div>


          <!-- 全球供应链服务 -->
          <div class="service-card">
            <h3 class="service-title">{{ $t('products.supply_chain.title') }}</h3>
            <p class="service-desc">Procurement/TAT/Price</p>
            <div class="image-placeholder strong-img">
              <img src="@/assets/1.png" alt="">
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="e2e-section" style="background: #fff;padding-bottom: 70px;padding-top: 70px">
      <div class="container">
        <h2>HEWVO Global E2E Digital Supply Chain Service Solution</h2>
        <p class="e2e-description">
          HEWVO provides end-to-end digital solutions covering enterprise-grade server configuration, assembly, manufacturing and full lifecycle supply chain services.
          We deliver a step-by-step, fully closed-loop and standardized supply chain service system spanning consultation, service preparation, implementation and continuous operation. Backed by mature operational experience and robust delivery capabilities, we enable customers to achieve rapid, reliable service rollout through a standardized service IT management platform.
        </p>

        <div class="solution-structure">
          <div class="solution-phase" style="background: #4A3C31">
            <h3>Remanufacturing Services</h3>
            <ul>
              <li>Configuration</li>
              <li>Assembly</li>
              <li>Manufacturing</li>
            </ul>
          </div>

          <div class="solution-phase" style="background: #FF6B35">
            <h3>Global Supply Chain Services</h3>
            <ul>
              <li>Planning & Consulting</li>
              <li>Global Logistics</li>
              <li>Testing / RTC</li>
            </ul>
          </div>

          <div class="solution-phase" style="background: #244b4c">
            <h3>E2E After Sales Service Management</h3>
            <ul>
              <li>CRM</li>
              <li>Spare parts</li>
              <li>Service channel</li>
            </ul>
          </div>


          <div class="solution-phase" style="background: #4787CF">
            <h3>Service IT System</h3>
            <ul>
              <li>Management</li>
              <li>Operation</li>
              <li>Report</li>
              <li>Settlement</li>
            </ul>
          </div>

        </div>
      </div>
    </div>

<!--    <div style="background: #fff">-->
<!--      <section class="products">-->
<!--        <h2>Global Remanufacturing center</h2>-->
<!--        <div class="pro-map-contain">-->
<!--          <img class="map" src="@/assets/products/map.jpg" alt="">-->
<!--          <div class="grid-data" style="padding-top: 40px">-->
<!--            <div class="stats-grid">-->
<!--              <div class="stat-card strong-img out-cel">-->
<!--                <div class="stat-number">6</div>-->
<!--                <div> Remanufacturing center</div>-->
<!--              </div>-->
<!--              <div class="stat-card strong-img">-->
<!--                <div style="display: flex;justify-content: center;align-items: center"><span-->
<!--                    class="stat-number">5</span>&nbsp;Industry-->
<!--                </div>-->
<!--                <div style="display: flex;justify-content: center;align-items: center"><span-->
<!--                    class="stat-number">16+</span>&nbsp;Product line-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="stat-card strong-img">-->
<!--                <div class="stat-number">200w-->
<!--                </div>-->
<!--                <div>-->
<!--                  Global total output-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="stat-card strong-img out-cel">-->
<!--                <div class="stat-number">30%+-->

<!--                </div>-->
<!--                <div> High-level technical talents</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="pic-grid">-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/1.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>Factory Outside</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/2.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>Factory Outside</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/3.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>RF Calibration</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/4.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>Repair Line</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/5.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>Testing Line</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/6.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>QC Line</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/7.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>TP Clean Room</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <img src="@/assets/products/9.png" alt="" style="border-radius: 10px;width: 130px;height: 96px;">-->
<!--            <div>Laboratory</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </section>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "products",
  computed: {
    is_en() {
      return this.$t('language') === 'English'
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  width: 1200px;
  margin: 0 auto;
  padding-top: 5rem;
}
.products {
  width: 1200px;
  margin: 0 auto;

  .pro-map-contain {
    display: flex;
    justify-items: center;
    align-items: center;
    justify-content: center;
    margin: 50px auto;

    .map {
      //margin: 30px auto;
      display: inline-block;
      width: 700px;
      margin-right: 20px;
    }

    .grid-data {
      display: inline-block;
      width: 400px;
    }
  }

  h2 {
    text-align: center;
    //color: var(--primary-color);
    color: #000000;
    margin-bottom: 2rem;
    font-size: 40px;
    font-weight: 500;
    font-family: Inter, Tahoma, Verdana, sans-serif;
  }

  .pic-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 20px;
    padding: 0 0;
    text-align: center;
    padding-bottom: 30px;

    img {
      width: 130px;
    }
  }

  /* 核心数据展示 */
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 2rem;
    margin: 0 0 3rem;
    padding: 0 0;
    text-align: center;
  }

  .stat-card {
    background: #fff;
    padding: 0.5rem;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .out-cel {
    background: #FF6B35;
    color: #fff;

    .stat-number {
      color: #fff !important;
    }
  }

  .stat-number {
    color: #FF6B35;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

}

/* 产品服务网格 */
.services-grid {
  margin: 50px auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;

  &.en {
    .service-card {
      height: 280px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    .service-title {
      height: 60px;
      text-align: center;
    }
  }
}

/* 服务卡片 */
.service-card {
  width: 180px;
  height: 250px;
  background: #F5F5F5;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #EEE;
}
.service-card:hover {
  transform: translateY(-10px);
  transition: transform 0.4s ease-out;
}


.service-title {
  color: #000;
  font-size: 1rem;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 2px solid #FF6B35;
}

.service-card:hover {
  .service-title {
    color: #FF6B35;
    transition: transform 1s;
  }
}

.service-desc {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 0.8rem;
  text-align: center;
}

.service-features {
  columns: 2;
  column-gap: 20px;
  margin-bottom: 20px;
}

.service-features li {
  color: #444;
  list-style: none;
  margin-bottom: 8px;
  position: relative;
  padding-left: 15px;
}

.service-features li::before {
  content: "•";
  color: #FF6B35;
  position: absolute;
  left: 0;
}

/* 图片占位 */
.image-placeholder {
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 1.2rem;

  img {
    height: 140px;
    width: 100%;
    object-fit: cover;
    border-radius: 5px;
  }
}
/* E2E解决方案样式 */
.e2e-section {
  //padding: 5rem 0;
  background: #E9F3FF;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    //padding: 0 2rem;
  }

  h2 {
    text-align: center;
    //color: var(--primary-color);
    color: #000000;
    margin-bottom: 2rem;
    font-size: 40px;
    font-weight: 500;
    font-family: Inter, Tahoma, Verdana, sans-serif;
  }

  .e2e-description {
    text-align: center;
    font-size: 22px;
    line-height: 33px;
    max-width: 900px;
    margin: 0 auto 3rem;
    color: #000;
    font-family: Inter, Tahoma, Verdana, sans-serif;
  }

  .solution-structure {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 2rem;
    font-family: Inter, Tahoma, Verdana, sans-serif;
    .solution-phase {
      border-radius: 5px;
      padding: 2rem;
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
      flex: 1;
      width: 300px;
      height: 220px;
      h3 {
        color: #fff;
        margin-bottom: 1rem;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
      }

      ul {
        list-style: none;
        padding: 0;
        color: #fff;
        li {
          padding: 0.7rem 0;
          border-bottom: 1px solid #eee;
          text-align: center;
          font-size: 1.1rem;

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }

    .solution-arrow {
      font-size: 2rem;
      color: #004E7C;
      font-weight: bold;
    }
  }

  .benefits-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;

    .benefit-card {
      background: white;
      border-radius: 10px;
      padding: 2rem;
      text-align: center;
      box-shadow: 0 5px 15px rgba(0,0,0,0.05);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      .benefit-icon {
        font-size: 3rem;
        margin-bottom: 1rem;
      }

      h4 {
        color: #004E7C;
        margin-bottom: 1rem;
      }

      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .e2e-section {
    .container {
      max-width: 100%;
      box-sizing: border-box;
    }
  }
  .stats-contain {
    display: block;
  }
  .hero {
    width: 100%;
    box-sizing: border-box;
  }
  .workflow-section .container {
    width: 100%;
    box-sizing: border-box;
    .regions-grid {
      grid-template-columns: repeat(1, 1fr);
    }
    .value-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }


  .map-wrapper {
    width: 100%;
  }

  .logo {
    font-size: 2.5rem;
  }
  .nav-links {
    gap: 1rem;
    font-size: 0.9rem;
  }
  .stat-number {
    font-size: 2rem;
  }
  .solution-structure {
    flex-direction: column !important;

    .solution-arrow {
      transform: rotate(90deg);
      margin: 1rem 0;
    }
  }
  .workflow-section::before {
    left: 40px !important;
  }
}
/* 响应式设计 */
@media (max-width: 768px) {
  .products {
    width: 100%;
  }
  .navbar {
    padding: 1rem 5%;
  }
  .brand {
    font-size: 1.8rem;
  }
  .nav-links {
    gap: 1.5rem;
  }
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 0 auto;
    justify-content: center;
    text-align: center;
    .service-card {
      width: 150px;
      height: 300px!important;
      display: block;
      margin: 0 auto;
      .service-title {
        height: 80px;
      }
    }
  }
  .service-desc {
    word-break: break-word;
  }
  .products  .pic-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
  .products .pro-map-contain .map {
    width: 100%;
    margin-right: 0;
  }
  .products .pro-map-contain {
    display: block;
  }
  .products .pro-map-contain .grid-data {
    display: block;
    margin: 0 auto;
  }
  .stats-grid {
    margin: 0 auto;
  }
}
</style>
